export default __webpack_public_path__ + "static/media/admin-icon-male-person-profile-avatar-with-gear-vector-25811110.d9e202fb.jpg";